module.exports = __webpack_public_path__ + "static/media/GPC_x3.c0395d6f.png";